import React, { useState } from 'react';
import PropTypes from "prop-types";
import '../../style/ProfilPictureList.css';
// img
import defaultImage from "/images/pdp/image-0.svg";

const ProfilPictureList = ({onClick, selectedPicture = ''}) => {
  const [selected, setSelected] = useState(selectedPicture);
  const profilPictureList = [
    'images/pdp/image-1.webp',
    'images/pdp/image-2.webp',
    'images/pdp/image-3.webp',
    'images/pdp/image-4.webp',
    'images/pdp/image-5.webp',
    'images/pdp/image-6.webp',
    'images/pdp/image-7.webp',
    'images/pdp/image-8.webp',
    'images/pdp/image-9.webp',
    'images/pdp/image-10.webp',
    'images/pdp/image-11.webp',
    'images/pdp/image-12.webp',
    'images/pdp/image-13.webp',
    'images/pdp/image-14.webp',
    'images/pdp/image-15.webp',
    'images/pdp/image-16.webp',
    'images/pdp/image-17.webp',
    'images/pdp/image-18.webp',
    'images/pdp/image-19.webp',
    'images/pdp/image-20.webp',
    'images/pdp/image-21.webp',
  ];

  const handleClick = (src) => {
    setSelected(src);
    onClick(src);
  }

  return (
    <>
      <ul className="profilPictureList_list">
        <li className="profilPictureList_element">
          <button onClick={() => handleClick("")} className={`profilPictureList_button ${selected === "" ? `active` : ``}`}>
            <img src={defaultImage} alt="Profil Picture" className="profilPictureList_image"/>
          </button>
        </li>
        {
        profilPictureList.map((src) => (
          <li key={src} className="profilPictureList_element">
            <button onClick={() => handleClick(src)} className={`profilPictureList_button ${selected === src ? `active` : ``}`}>
              <img src={`${import.meta.env.BASE_URL}${src}`} alt="Profil Picture" className="profilPictureList_image"/>
            </button>
          </li>
        ))}
      </ul>
    </>
  );
};

ProfilPictureList.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ProfilPictureList;